import {$body} from '../../../Constants';
import SwiperSlider from '../../../Elements/SwiperSlider';

/**
 * Header Slider
 */
const HeaderSlider = (() => {
	/**
	 * Selector
	 *
	 * @var { Object }
	 */
	const Selector = {
		HEADER_SLIDER: '.header-images.swiper-container',
	};

	/**
	 * Header Slider
	 *
	 * @class
	 * @augments SwiperSlider
	 */
	class HeaderSlider extends SwiperSlider {
		// Public

		/**
		 * Handles ready event
		 *
		 * @return void
		 */
		onReady() {
			super.onReady();

			this.setOptions({
				slidesPerView: 1,
				grabCursor: true,
				effect: 'fade',
				loop: this.$element.find('.header-image').length > 1,
				pagination: {
					el: this.constructor.Selector.PAGINATION,
					clickable: true
				},
				navigation: {
					nextEl: '.swiper-button-next',
					prevEl: '.swiper-button-prev',
				},
				// Disable preloading of all images
				preloadImages: false,
				// Enable lazy loading
				lazy: true
			});

			if (!window.matchMedia('print').matches) {
				this._initialize();
			}
		}
	}

	return HeaderSlider._getElements($body.find(Selector.HEADER_SLIDER), HeaderSlider);
})();

export default HeaderSlider;
